import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
const loadNewComponent = () =>
  Promise.all([
    import(/* webpackChunkName: "snp-documents-tab" */ "./components"),
  ]).then(([importedModule0]) => {
    const component = importedModule0.default;
    return component;
  });
// .catch(err => {
//   throw err;
// });
const updateStore = () => ({
  path: "school-documents",
  component: withAsyncRouteLoading(loadNewComponent),
});
export default updateStore;
